import Req, { OpsBackend } from "./request";
// import UReq from "../page/usms/utils/ucloudRequest";

import Config, { GetEnv } from "../utils/config";
// import { RecordTypeId } from "../page/usms/utils/const";
// import { GetSelfPermissions } from './acl';
import Auth from "../utils/auth";
// import { getSignatureParams } from "../page/usms/utils/getSignatureParams";

// import { getSmsType } from "../page/localStorage";

/* 运营平台API */
function EmailOpsFetch(action, params, getResult, adminAction) {
	const data = {
		Action: action,
		AdminAction: adminAction,
		SMSCategory: "EMAIL",
		Backend: OpsBackend.UsmsBackend,
		...params
	}
	if (adminAction) {
		delete data.Backend;
	}
	return Req({
		method: "post",
		baseURL: "",
		url: Config.OpsAPI[GetEnv()],
		timeout: 60000,
		data,
		headers: { remote_user: Auth.getLocalAuthName() }
	}).then(res => {
		return getResult ? getResult(res) : res;
	});
}

/* 业务方API */
function EmailFetch(action, params, getResult) {
	return Req({
		method: "post",
		url: Config.OpsAPI[GetEnv()],
		timeout: 60000,
		data: {
			Action: action,
			Backend: OpsBackend.UsmsBackend,
			SMSCategory: "EMAIL",
			...params
		},
		headers: { remote_user: Auth.getLocalAuthName() }
	}).then(res => {
		return getResult ? getResult(res) : res;
	});
}

export const DescribeEmailTemplate = params => {
	return EmailFetch("DescribeEmailTemplate", params)
}

export const UpdateEmailTemplateStatus = params => {
	return EmailFetch("UpdateEmailTemplateStatus", params)
}

export const DescribeEmailTemplateWithRisk = params =>
	EmailOpsFetch("GetActionWithCompanySelfRisk", params, res => (res && res.Data) || {}, "DescribeEmailTemplate");

export const DescribeAuditTemplate = params =>
	EmailFetch("DescribeAuditTemplate", params, res => (res && res.Data) || []);

export const AddLogRecord = params => EmailOpsFetch("AddLogRecord", params);
